/**
 * Friendly headlines for a stock's `problem_code`. Admins still see the raw
 * `fail_detail` underneath — this only saves them parsing worker text to tell
 * "the supplier must fix their account" from "our side had a bad day".
 *
 * Codes are produced by ProblemCode() in internal/stock/entity/model.go.
 */
export const STOCK_PROBLEM_LABELS: Record<string, string> = {
  wrong_password: 'Wrong password',
  wrong_backup_code: 'Invalid backup codes',
  signed_into_another_device: 'Signed into another device',
  two_factor_not_enabled: 'Two-factor auth not enabled',
  account_locked: 'Account locked (banned)',
  transfer_market_closed: 'Transfer market locked',
  unassigned_list_full: 'Unassigned item list full',
  pc_account_not_supported: 'PC account — not supported',
  login_failed: 'Login failed repeatedly',
  not_enough_coins: 'Not enough coins to start',
  balance_at_threshold: 'Already at the stop threshold',
};

/** Codes the supplier fixes by topping up or re-arming, not by repairing the account. */
const WARNING_CODES = new Set(['balance_at_threshold', 'not_enough_coins']);

export function isStockProblemWarning(code: string | undefined): boolean {
  return Boolean(code) && WARNING_CODES.has(code as string);
}
